import React, { useCallback, useEffect, useState } from "react";
import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Box from '@mui/material/Box';

import TopSection from "../../LT/TopSection";
import TabSection from "../../../components/common/TabSection";
import { fetchMetricsData } from "../../../redux/actions/DashboardMetricsCD";

const Dashboard = () => {
  const dispatch = useDispatch();
  const [powerBIAccessToken, setPowerBIAccessToken] = useState("");
  const [powerBIEmbedURL, setPowerBIEmbedURL] = useState("");
  const [powerBIReportID, setPowerBIReportID] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [acnPowerBIAccessToken, setAcnPowerBIAccessToken] = useState("");
  const [acnPowerBIEmbedURL, setAcnPowerBIEmbedURL] = useState("");
  const [acnPowerBIReportID, setAcnPowerBIReportID] = useState("");

  const group_id = process.env.REACT_APP_PBI_CD_DASHBOARD_GROUP_ID;
  const report_id = process.env.REACT_APP_PBI_CD_DASHBOARD_REPORT_ID;
  const acn_group_id = process.env.REACT_APP_ACN_GROUP_ID;
  const acn_report_id = process.env.REACT_APP_ACN_REPORT_ID;
  
  const getPowerBIDashboardDetails = useCallback(async () => {
    try {
      const responsePowerBIDashboardDetails = await dispatch(fetchMetricsData({
        dynamicEndpoint: `api/powerBI/embedDetails/group/${group_id}/report/${report_id}`,
      }));
      if (responsePowerBIDashboardDetails?.meta?.requestStatus === 'fulfilled') {
        setPowerBIEmbedURL(responsePowerBIDashboardDetails?.payload?.embedUrl);
        setPowerBIReportID(responsePowerBIDashboardDetails?.payload?.reportId);
        setPowerBIAccessToken(responsePowerBIDashboardDetails?.payload?.accessToken)
      } else {
        toast.error(responsePowerBIDashboardDetails?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }
  }, [dispatch, group_id, report_id]);

  const getAcnPowerBIDashboardDetails = useCallback(async () => {
    try {
      const responseAcnPowerBIDashboardDetails = await dispatch(fetchMetricsData({
        dynamicEndpoint: `api/powerBI/embedDetails/group/${acn_group_id}/report/${acn_report_id}`,
      }));
      if (responseAcnPowerBIDashboardDetails?.meta?.requestStatus === 'fulfilled') {
        setAcnPowerBIEmbedURL(responseAcnPowerBIDashboardDetails?.payload?.embedUrl);
        setAcnPowerBIReportID(responseAcnPowerBIDashboardDetails?.payload?.reportId);
        setAcnPowerBIAccessToken(responseAcnPowerBIDashboardDetails?.payload?.accessToken);
      } else {
        toast.error(responseAcnPowerBIDashboardDetails?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }
  }, [dispatch, acn_group_id, acn_report_id]);

  useEffect(() => {
    getPowerBIDashboardDetails();
  }, [getPowerBIDashboardDetails])

  useEffect(() => {
    getAcnPowerBIDashboardDetails();
  }, [getAcnPowerBIDashboardDetails]);

  const embedConfig = {
    type: 'report',
    id: powerBIReportID,
    embedUrl: `${powerBIEmbedURL}`,
    accessToken: powerBIAccessToken,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
      },
      navContentPaneEnabled: false,
      layoutType: models.LayoutType.Custom,
      customLayout: {
        displayOption: models.DisplayOption.FitToWidth,
      },
    },
  }

  const acnEmbedConfig = {
    ...embedConfig,
    id: acnPowerBIReportID,
    embedUrl: acnPowerBIEmbedURL,
    accessToken: acnPowerBIAccessToken,
  };

  return (
    <>
      <TopSection
        labelList={[
          { title: "Home", path: "/landing-page" },
          { title: "Dashboard" },
        ]}
        hideHeader={true}
        headerName={"Contract Automation Tool - Usage Metrics Dashboard"}
      />
      <Box sx={{
        '& .MuiTab-root.Mui-selected': { color: '#000' },
        '& .MuiTabs-indicator': { backgroundColor: '#000' },
      }}>
        <TabSection
          label={["Usage Metrics", "Advanced Contract Notification Report"]}
          value={activeTab}
          handleChange={(event, value) => setActiveTab(value)}
          ariaLabel="Contract automation dashboard reports"
        />
      </Box>
      {activeTab === 0 && (
        <div className="powerBi_cls_cd">
          {embedConfig?.embedUrl && embedConfig?.accessToken &&
            <PowerBIEmbed
              embedConfig={embedConfig}
            />}
        </div>
      )}
      {activeTab === 1 && (
        <div className="powerBi_cls_cd">
          {acnEmbedConfig?.embedUrl && acnEmbedConfig?.accessToken &&
            <PowerBIEmbed
              embedConfig={acnEmbedConfig}
            />}
        </div>
      )}
    </>
  );
};

export default Dashboard;
